import React, {MouseEventHandler, ReactNode} from 'react'

type Props = {
  children?: ReactNode
}

const ButtonComp: React.FC<Props> = ({children}) => {
  return (
    <>
      <div className='fv-plugins-message-container'>
        <div className='fv-help-block'>
          <span role='alert'>{children}</span>
        </div>
      </div>
    </>
  )
}
export default ButtonComp
